var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner edi-bill-search-selector",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("SeaExport.SearchJobNo"),
            width: "1000px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: function($event) {
              return _vm.cancel()
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "60px", "label-position": "left" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_BusinessNo")
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "260px" },
                                attrs: { no: "1" },
                                model: {
                                  value: _vm.elForm.jobNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.elForm, "jobNo", $$v)
                                  },
                                  expression: "elForm.jobNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_ChineseFirstVesselName"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "260px" },
                                attrs: {
                                  no: "2",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Vessel,
                                  "allow-create": "",
                                  "callback-method-type": "value",
                                  "default-value": _vm.elForm.vessel || "",
                                  "callback-params": { key: "vessel" }
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_VoyageNo")
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "260px" },
                                attrs: { no: "3" },
                                model: {
                                  value: _vm.elForm.voyageFlight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.elForm, "voyageFlight", $$v)
                                  },
                                  expression: "elForm.voyageFlight"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_PortOfDischarge")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "260px" },
                                attrs: {
                                  no: "4",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  "callback-method-type": "value",
                                  "default-value":
                                    _vm.elForm.dischargingPortCode || "",
                                  "callback-params": {
                                    key: "dischargingPortCode"
                                  }
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AuthorizedClient")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "260px" },
                                attrs: {
                                  no: "5",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": {
                                    customer: true,
                                    companyLob: "seaExport",
                                    active: true
                                  },
                                  "callback-method-type": "value",
                                  "default-value": _vm.elForm.customerId || "",
                                  "callback-params": { key: "customerId" }
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_CarrierShip")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "260px" },
                                attrs: {
                                  no: "6",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": {
                                    companyLob: "seaExport",
                                    seaCmp: true,
                                    active: true
                                  },
                                  "callback-method-type": "value",
                                  "default-value": _vm.elForm.carrierId || "",
                                  "callback-params": { key: "carrierId" }
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_SailingDate")
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    width: "260px"
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "125px" },
                                    attrs: {
                                      no: "7",
                                      type: "date",
                                      "value-format": "yyyy-MM-dd"
                                    },
                                    model: {
                                      value: _vm.elForm.dfETD1,
                                      callback: function($$v) {
                                        _vm.$set(_vm.elForm, "dfETD1", $$v)
                                      },
                                      expression: "elForm.dfETD1"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "margin-left": "1px",
                                        "margin-right": "1px"
                                      }
                                    },
                                    [_vm._v("-")]
                                  ),
                                  _c("el-date-picker", {
                                    staticStyle: { width: "125px" },
                                    attrs: {
                                      no: "8",
                                      type: "date",
                                      clearable: "",
                                      "value-format": "yyyy-MM-dd"
                                    },
                                    model: {
                                      value: _vm.elForm.dfETD2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.elForm, "dfETD2", $$v)
                                      },
                                      expression: "elForm.dfETD2"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "MBL NO" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "260px" },
                                attrs: { no: "9" },
                                model: {
                                  value: _vm.elForm.mbl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.elForm, "mbl", $$v)
                                  },
                                  expression: "elForm.mbl"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { no: "15" },
                                  model: {
                                    value: _vm.elForm.notEqPAgentAndFAgent,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.elForm,
                                        "notEqPAgentAndFAgent",
                                        $$v
                                      )
                                    },
                                    expression: "elForm.notEqPAgentAndFAgent"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.DestinationPortAgentIsNotEqualToDesignatedFreightAgent"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "SONO" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "260px" },
                                attrs: { no: "10" },
                                model: {
                                  value: _vm.elForm.soNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.elForm, "soNo", $$v)
                                  },
                                  expression: "elForm.soNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "-60px" },
                                  attrs: { no: "11", type: "primary" },
                                  on: { click: _vm.searchHandler }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "12", type: "primary" },
                                  on: { click: _vm.reset }
                                },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { "min-height": "350px", padding: "0" }
            },
            [
              _vm.params.selectType === "multiple" && _vm.innerVisible
                ? _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "350px" },
                    attrs: {
                      "config-module": "130200",
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefsMultiple,
                      "row-data": _vm.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: function(params) {
                        return (_vm.gridApi = params.api)
                      }
                    }
                  })
                : _vm._e(),
              _vm.params.selectType === "single" && _vm.innerVisible
                ? _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "350px" },
                    attrs: {
                      "config-module": "130201",
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefsSingle,
                      "row-data": _vm.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: function(params) {
                        return (_vm.gridApi = params.api)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row row-pagination" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchConditions.total > 0,
                    expression: "searchConditions.total>0"
                  }
                ],
                attrs: {
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.searchHandler
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "13", type: "primary" },
                  on: { click: _vm.confirm }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "14" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }